import React, { useContext } from 'react';
import { AppContext } from '../pages/playgame';
import Popup from 'reactjs-popup';
import { CompactTable } from '@table-library/react-table-library/compact';

function Leaderboard({ isOpen, onClose, leaderboard: leaderboardProp }) {
    // Support both context and prop-based leaderboard data
    const context = useContext(AppContext);
    const leaderboard = leaderboardProp || (context ? context.leaderboard : []);
    
    const columns = [
        { label: 'Name', renderCell: (item) => item.playername },
        { label: 'Guesses', renderCell: (item) => item.guesses }
    ]

    // Controlled mode (for icon button) - uses isOpen/onClose
    if (isOpen !== undefined && onClose) {
        return (
            <Popup 
                open={isOpen}
                position="center center"
                arrow={false}
                modal={true}
                closeOnDocumentClick={true}
                closeOnEscape={true}
                onClose={onClose}
                className="leaderboard-overlay"
                contentStyle={{
                    maxWidth: '95vw',
                    maxHeight: '85vh',
                    marginTop: '5vh',
                    marginBottom: '5vh',
                    overflow: 'auto'
                }}
            >
                {(close) => (
                    <div className="gameOver popup-leaderboard" style={{ height: '100%', maxHeight: '85vh' }}>
                        <button onClick={close} className="close-button">
                            &times;
                        </button>
                        <div className="table-container">
                            <h2 className="leaderboard-title">Leaderboard</h2>
                            <div className="table-scroll">
                                <CompactTable data={{ nodes: leaderboard }} columns={columns} />
                            </div>
                        </div>    
                    </div>
                )}
            </Popup>
        );
    }

    // Uncontrolled mode (for GameOver) - uses trigger
    return (
        <Popup 
            trigger={<button className="leaderboard-button submit">View leaderboard</button>}
            defaultOpen={false}
            position="top center"
            arrow={false}
            modal={true}
            closeOnDocumentClick={false}
            closeOnEscape={false}
            className="leaderboard-overlay"    
            contentStyle={{
                position: 'absolute',
                marginTop: '10px'
            }}
        >
            {(close) => (
                <div className="gameOver popup-leaderboard">
                    <button onClick={close} className="close-button" >
                        &times;
                    </button>
                    <div className="table-container">
                        <h2 className="leaderboard-title">Leaderboard</h2>
                        <div className="table-scroll">
                            <CompactTable data={{ nodes: leaderboard }} columns={columns} />
                        </div>
                    </div>    
                </div>
            )}
        </Popup>
    )
}


export default Leaderboard;